import styled from 'styled-components';

export const Wrapper = styled.main`
  padding: 8px 30px 70px;
  @media (max-width: 767px) {
    padding-left: 16px;
    padding-right: 16px;
  }
  min-height: calc(100vh - 120px);

  .selected-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    padding: 12px 0 20px;
    align-items: center;

    @media (max-width: 767px) {
      padding-top: 0;
    }
  }
`;
